<div class="activity-log-outer-container" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="8px"
  fxLayout.lt-md="column" fxLayoutAlign.lt-md="start start" fxLayoutGap.lt-md="4px">
  <!-- First row with Offer Name & Status menu -->
  <div fxLayout="row wrap" fxLayoutAlign="space-between" style="width: 100%">
    <!-- Offer Name -->
    <div fxLayout="row wrap" fxLayoutAlign="space-between" style="width: 100%">
      <h2></h2>
      <button mat-icon-button color="primary" (click)="processCurrentOffer()">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </div>

  <!-- Container with image & activity log -->
  <div fxLayout="row" fxLayoutAlign="space-between" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start start"
    class="activity-log-inner-container">
    <div class="offer-details-table" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="16px"
      fxLayout.lt-md="column" fxLayoutAlign.lt-md="start start" fxLayoutGap.lt-md="4px"
      *ngIf="activityDataSource?.length > 0">
      <table mat-table [dataSource]="activityDataSource" class="mat-elevation-z8">
        <!--- Note that these columns can be defined in any order.
      The actual rendered columns are set as a property on the row definition" -->

        <ng-container matColumnDef="activity">
          <th mat-header-cell *matHeaderCellDef>Activity</th>
          <td mat-cell *matCellDef="let element" style="white-space: normal; padding: 10px 0px">
            {{ element.Activity }}
          </td>
        </ng-container>

        <ng-container matColumnDef="user">
          <th mat-header-cell *matHeaderCellDef>User</th>
          <td mat-cell *matCellDef="let element">
            {{ element.User }}
          </td>
        </ng-container>

        <ng-container matColumnDef="time">
          <th mat-header-cell *matHeaderCellDef>Time</th>
          <td mat-cell *matCellDef="let element">
            {{ element.Time | date : "MMM d, y, h:mm:ss a" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="details">
          <th mat-header-cell *matHeaderCellDef>Details</th>
          <td mat-cell *matCellDef="let element; let i = index" style="cursor: pointer; color: #192f41"
            (click)="viewDetails(i)">
            View
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr>
          <td *ngIf="!activityDataSource || activityDataSource.length == 0">
            <p><b>No Data Found</b></p>
          </td>
        </tr>
      </table>
    </div>

    <div fxLayout="row" fxLayoutAlign="center center" *ngIf="!activityDataSource || activityDataSource.length == 0"
      style="width: 100%; padding-top: 1rem" class="offer-details-table">
      <p><b>No Activity Logged Yet</b></p>
    </div>
  </div>
</div>

<ng-template #loading>
  <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</ng-template>